import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit', {
        url: '/edit/:hardTokenId',
        params: {token: {}, hardtokenId: null},
        redirectTo: 'company.hard-token-management.edit.settings',
        //component: 'editHardToken',
         views: {
            '@company': 'editHardToken'
        },
        resolve: {token}
    })
    

}

/** @ngInject */
function token($stateParams,HardTokenService) {
	if(Object.keys($stateParams.token).length!=0){
    	return $stateParams.token;
    } else {
		const id= $stateParams.hardTokenId;
		return HardTokenService
        .get(id);
	}
}






// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/hard-token-edit.state.js